export type TrackingLinkModel = {
  cache_key: number,
  key?: string,
  id: number,
  owner_id: number,
  owner_type: string,
  recipient_id?: number,
  recipient_type?: string,
  shortened_url?: string,
  subject_id: number,
  subject_type: string,
  title: string,
  token?: string,
  total_views?: number,
  url: string,
}

export type TrackingLinkRequestOptions = {}

const state = {
  id: null,
  owner_id: undefined,
  owner_type: '',
  recipient_id: undefined,
  recipient_type: '',
  subject_id: undefined,
  subject_type: '',
  title: '',
  url: '',
}

export const requiredFields = [
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'subject_id' },
  { key: 'subject_type' },
  { key: 'title' },
  { key: 'url' },
]

export default state
